









































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { storeDokter } from "@/store/modules/dokter";
import EncounterIndex from "@/services/EncounterIndex";

@Component({})
export default class ModalListParticipant extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title!: string;
  @Prop() dtDokter!: object;
  @Prop() dtReg!: object;
  @Prop({
    default: {
      dpjp: [
        {
          user_id: null,
          role: "dpjp"
        }
      ],
      raber: [],
      konsul: []
    }
  })
  participant!: object;

  @Ref() refDocRaber: HTMLElement;
  @Ref() refDocKonsul: HTMLElement;

  saving = false;
  alert: string;
  success: string;
  dpjp: Array<{
    user_id: number;
    role: string;
  }> = [];
  docRaber: Array<{
    user_id: number;
    role: string;
  }> = [];
  docKonsul: Array<{
    user_id: number;
    role: string;
  }> = [];

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  @Watch("value")
  changedValue(val) {
    if (val) {
      if (this.participant) {
        this.dpjp = this.participant["dpjp"]?.map(item => {
          return { user_id: item.user_id, role: "dpjp" };
        });
        this.docRaber = this.participant["raber"]?.map(item => {
          return { user_id: item.user_id, role: "raber" };
        });
        this.docKonsul = this.participant["konsul"]?.map(item => {
          return { user_id: item.user_id, role: "konsul" };
        });
      }
    } else {
      this.dpjp = [];
      this.docRaber = [];
      this.docKonsul = [];
    }
  }

  changeDpjp(val) {
    if (!this.saving) {
      this.saving = true;

      EncounterIndex.changeDpjp(
        this.dtReg["register"],
        this.dtReg["pasienRm"],
        this.dpjp
      )
        .then(resp => {
          if (resp.status == 1) {
            this.$emit("participantChanged");
          }
        })
        .catch(() => {
          this.dpjp = [];
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  get docRaberParams() {
    return this.docRaber.concat(this.docKonsul).filter(it => it.user_id);
  }

  saveParticipant() {
    if (!this.saving) {
      this.saving = true;

      EncounterIndex.changeRaber(
        this.dtReg["register"],
        this.dtReg["pasienRm"],
        this.docRaberParams
      )
        .then(resp => {
          this.$emit("participantChanged");
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  addDocKonsul() {
    this.docKonsul.push({
      user_id: null,
      role: "konsul"
    });

    this.$nextTick(() => {
      this.refDocKonsul[this.docKonsul.length - 1].focus();
    });
  }

  addDocRaber() {
    this.docRaber.push({
      user_id: null,
      role: "raber"
    });

    this.$nextTick(() => {
      this.refDocRaber[this.docRaber.length - 1].focus();
    });
  }

  rmRaberItem(index) {
    this.docRaber.splice(index, 1);
  }

  rmKonsulItem(index) {
    this.docKonsul.splice(index, 1);
  }
}
